import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { groupType } from "../../constants/constants";
import { api1 } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import CommonDropdown from "../../components/commonDropDown/CommonDropDown";
import CommonTextField from "../../components/commonTextField/CommonTextField";
import MultiSelectDropDown from "../../components/multiSelect/MultiSelect";
import FlexibleTextarea from "../../components/textArea/FlexibleTextarea";
import TransparentButton from "../../components/transparentButton/TransparentButton";
import WelcomeCard from "../../components/WelcomeCard";
import { useLocation, useNavigate } from "react-router-dom";
import { createGroup } from "../../services/groupchatService";
import { toast } from "react-toastify";

const CreateGroup = () => {
  const [users, setUsers] = useState([]);
  const { id: admin } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { groupData } = location.state || {};

  const {
    register,
    watch,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const fetchUsers = async () => {
    try {
      const response = await api1.get("/api/user");
      const formatted = response.data.map((user) => ({
        label: `${user.firstName} ${user.lastName}`,
        value: user._id,
      }));

      setUsers(formatted);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const onSubmit = async (data) => {
    try {
      const groupPayload = {
        name: data.groupName,
        description: data.groupDescription || "",
        type: data.groupType || "learning",
        participants: data.participants || [],
        admin,
      };

      const result = await createGroup(groupPayload);
      if (result?.success) {
        toast.success("Group created successfully");
        navigate("/dashboard/groups/list");
      } else {
        toast.error(result?.error || "Failed to create group");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      toast.error("Failed to create group");
    }
  };

  const onUpdate = async (data) => {
    try {
      const updateData = {
        name: data.groupName,
        description: data.groupDescription || "",
        type: data.groupType || "learning",
      };

      const result = await api1.put(API_ENDPOINTS.UPDATE_GROUP(groupData._id), updateData);
      if (result.data?.success) {
        toast.success("Group updated successfully");
        navigate("/dashboard/groups/list");
      } else {
        toast.error("Failed to update group");
      }
    } catch (error) {
      console.error("Error updating group:", error);
      toast.error("Failed to update group");
    }
  };

  useEffect(() => {
    if (groupData) {
      reset({
        groupName: groupData.name || "",
        groupType: groupData.groupType || "",
        groupDescription: groupData.description || "",
      });
    }
  }, [groupData, reset]);

  return (
    <div className="flex flex-col gap-6">
      <WelcomeCard title={"Create Group"} />
      <form
        className="bg-white shadow-md rounded-lg p-4 flex flex-col gap-6"
        onSubmit={handleSubmit((data) => {
          if (groupData) {
            onUpdate(data);
          } else {
            onSubmit(data);
          }
        })}
      >
        <div className=" grid grid-cols-1 md:grid-cols-2 gap-4">
          <CommonTextField
            name="groupName"
            label="Group Name"
            register={register}
            required
            errors={errors}
            placeholder="Enter Group Name"
          />
          <CommonDropdown
            label="Group Type"
            name="groupType"
            register={register}
            errors={errors}
            required
            options={groupType}
            defaultValue={watch("groupType")}
          />
          <MultiSelectDropDown
            label="Select Participants"
            name="participants"
            register={register}
            errors={errors}
            options={users}
            value={watch("participants") || []}
            onChange={(selectedValues) => {
              setValue("participants", selectedValues, {
                shouldValidate: true,
              });
            }}
          />
        </div>
        <FlexibleTextarea
          label={"Group Description"}
          name="groupDescription"
          register={register}
          required
          errors={errors}
          placeholder="Write a description..."
        />
        <TransparentButton
          buttonText={groupData ? "Update Group" : "Create Group"}
        />
      </form>
    </div>
  );
};
export default CreateGroup;
